import React, { HTMLAttributes } from "react";
import "./grid-table-row.css";

export interface GridTableRowUIProps {
  /** Selectable row (default true) */
  uiSelectable?: boolean;
  /** Header row (makes it unselectable) */
  uiHeader?: boolean;
  /** True if even rows should have different color */
  uiEven?: boolean;
  /** Display border */
  uiBorder?: boolean;
}

export type GridTableRowProps = HTMLAttributes<HTMLDivElement> &
  GridTableRowUIProps;

/**
 * Table row component for grid layouts.
 */
export default function GridTableRow({
  className,
  uiSelectable = true,
  uiHeader = false,
  uiEven = false,
  uiBorder = false,
  children,
  ...rest
}: GridTableRowProps) {
  const classes = [
    "grid-table-row",
    uiHeader && "grid-table-row--header",
    uiSelectable && !uiHeader && "grid-table-row--selectable",
    uiEven && "grid-table-row--even",
    (uiBorder || uiHeader) && "grid-table-row--border",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
